// Tooltips everywhere
$(function() {
    $('[data-toggle="tooltip"]').tooltip();
});